import { component } from "picoapp";
import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import styled from "styled-components";

function FreeGiftModal({node, ctx}) {
  const [products, setProducts] = useState();
  const [showModal, setShowModal] = useState(false);
  const [total, setTotal] = useState(0)
  const [freeItem, setFreeItem] = useState(false);

  function loadGWPProducts() {
    fetch('/collections/new-gwp/products.json')
    .then(response => response.json())
    .then(data => {
        const products = data.products.filter(product => product.variants[0].available).slice(0, 3);
        setProducts(products)
    });
  }
  function addGiftToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          quantity: 1,
          id: variantId,
          properties: {
            free_gift: true // Mark as free gift
          }
        }]
      })
    })
    .then(response => response.json()
      .then(() => {
        // Hide the modal
        setShowModal(false);
        document.dispatchEvent(new CustomEvent('cart:refresh')); // Trigger a cart refresh event
        new Promise(async (resolve) => {
          resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
          document.querySelector("cart-drawer").show()
        })
        setFreeItem(true);
      })
    )
    .catch(err => {
        console.log("err:", err)
    })
  }
  useEffect(()=> {
    function getCartTotal() {
      fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        const freeGiftItem = data.items.filter(item => item.properties && item.properties.free_gift)
        let tot;
        if (freeGiftItem[0]) {
          setFreeItem(true);
          tot = (data.total_price  - freeGiftItem[0].final_price) / 100
        } else {
          setFreeItem(false);
          tot = data.total_price / 100
        }
        setTotal(tot);
      })
    }
    getCartTotal();
    document.addEventListener("cart:change", getCartTotal);

  },[])
  useEffect(()=> {
    if (total >= 100) {
      loadGWPProducts();
      setShowModal(true);
    } else {
      setShowModal(false)
      setFreeItem(false);
    }
  },[total])
  useEffect(()=> {
    if (total >= 100) {
      const claimButton = document.querySelector(".claim-now-button");
      claimButton?.addEventListener("click", () => {
        setShowModal(true)});
    }
    console.log("showModal:", showModal, total);
  },[showModal, total])
  
  useEffect(() => {
    console.log("freeItem", freeItem);
  }, [freeItem])


  return showModal && !freeItem && (
  <div id="gwp-modal" className="gwp-modal">
    <div className="gwp-modal-content">
      <span id="closeModal" className="gwp-modal-close" onClick={() => setShowModal(false)}>&times;</span>
      <h3 className="selectFreeHeader" alt="select free gift">Select Your Free Gift</h3>
      <div id="freeGiftOptions" className="gwp-modal-products">
        {products && products.map((product, i) => (
          <div key={i} className="modal-product-card">
            <img src={product.images[0].src} alt={product.title} className="product-card__image"/>
            <p className="product-title">{product.title}</p>
            <button className="add-to-cart-button" data-variant-id={product.variants[0].id} onClick={()=>{addGiftToCart(product.variants[0].id)}}>Add to Cart</button>
          </div>
        ))}
      </div>
    </div>
  </div>
  )
  
}
export default component((node, ctx) => {
  const element = <FreeGiftModal node={node} ctx={ctx} />;
  const root = createRoot(node);
  root.render(element);

  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});